import React, { Component } from 'react';
import Card from '@material-ui/core/Card';
import './AddLoanWithoutInterest.scss';
import Input from '@material-ui/core/Input';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Sidebar from '../../sidebar/sidebar';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import 'date-fns';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';        
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment'
import AddLoan from '../AddLoans/AddLoan';
import {BaseUrl} from "../../../Environment";
import { withNamespaces } from 'react-i18next';
import { Select } from '@mui/material';
import { getSecureItem } from '../../../utilsFunctions';
import { addBankAccountAPI, getAllBankAccountsDataAPI, fetchAPIData } from "../../../service/service";
import { loan } from '../../../assets/images';
import searchicon from '../../../assets/images/searchicon.svg';

const axios = require('axios')
const EntryLoanType = [
  {label: 'Flat Interest', value: 'Collection method'},
  {label: 'Reducing Balance (EMI)', value: 'EMI Method'},
  {label: 'Balloon Repayment', value: 'Balloon Method'},
  ...(getSecureItem("loggedinUserCompany") == '2998'
    ? [
        {
          value: 'Flexi EMI',
          label: 'Flexi EMI',
        },
      ]
    : []),
]
class AddLoanWithoutInterest extends Component {
  optionsOfAccount = [{ label: "Cash", value: "0000" }];
  constructor(props) {
    super(props);
    this.state = {
      whenNotPaid: "",
      autoUpdateNPD: "No",
      file: '',
      imagePreviewUrl: '',
      changeColorname: '1px solid #D4D4D5',
      changeColoremail: '1px solid #D4D4D5',
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColoremail6: "1px solid #D4D4D5",
      changeColoremail7: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      // changeColoremail: '1px solid #D4D4D5',
      changeColorcategory: "1px solid #D4D4D5",
      category: "collector",
      collectionagent: "",
      SelectedDate: new Date(),
      createdAt: new Date(),
      selectedBrand: "",
      brands: [{ id: 1, name: "One Time" },{ id: 2, name: "Monthly" }, { id: 3, name: "Weekly" }, { id: 3, name: "Bi-Weekly" }, { id: 4, name: "Daily" }, { id: 5, name: "Ten_Daily" }],
      loantenure: "",
      distamount: "",
      installment: "",
      totalAmount: "",
      previousOverDueAmount:"",
      previousLoanId:"",
      processFee: 0,
      selectedLoanType:"",
      feedetails: [],
      feeInputs: {},
      feeValues: {},
      totalFee: 0,
      tenure: "",
      OpeningBalance: "",
      ClosingBalance: "",
      laontype: "",
      LaonType: [],
      bankAccountData: [],
      accountId: "",
      labelOfBank: "",
      method: "",
      penalty: "",
      customerId: "",
      coApplicantCustomerId: null,
      guarantorCustomerId: null,
      userId: "",
      Collectors: [],
      collectionArr: [],
      scheduleArr: [],
      userdetails: [],
      choosecustmr: "",
      rows: [],
      chooseBorrower: "",
      chooseCoApplicant: "",
      chooseGuarantor: "",
      allCustomer: [],
      allBorrower: [],
      allCoApplicant: [],
      allGuarantor: [],
      showBorrowerDropdown: false,
      showCoApplicantDropdown: false,
      showGuarantorDropdown: false,
      searchdoneBorrower: false,
      searchdoneCoApplicant: false,
      searchdoneGuarantor: false,
      path: "",
      afterSelect: "",
      loanTypeId: "",
      amountfrom: "0",
      amountto: "0",
      fixedRoi: "0",
      daysfrom: "0",
      daysto: "0",
      onetimefrom: "0",
      onetimeto: "0",
      weeksfrom: "0",
      weeksto: "0",
      monthsfrom: "0",
      monthsto: "0",
      days: "none",
      weeks: "none",
      months: "none",
      onetime:"",
      Entrylaontype: "Collection method",
      calInterest:"none",
      InterestButtonAction:"none",
      ButtonAction:"",
      isdisabled:true,
      searchdone:false,
      typeOfBM: "interestOnly",
      roiBM: "",
      lastEmiPercentageBM: "",
    };
    this.borrowerWrapperRef = React.createRef();
    this.coApplicantWrapperRef = React.createRef();
    this.guarantorWrapperRef = React.createRef();
    this.nameBox = this.nameBox.bind(this)
    this.numberBox = this.numberBox.bind(this)
    this.annualBox1 = this.annualBox1.bind(this)
    this.annualBox = this.annualBox.bind(this)
    this.emailBox = this.emailBox.bind(this)
    this.emailBox1 = this.emailBox1.bind(this)
    this.emailBox2 = this.emailBox2.bind(this)
    this.emailBox3 = this.emailBox3.bind(this)
    this.emailBox4 = this.emailBox4.bind(this)
    this.emailBox5 = this.emailBox5.bind(this)
    this.emailBox6 = this.emailBox6.bind(this);
    this.emailBox7 = this.emailBox7.bind(this);
    this.calculationwithnointerest = this.calculationwithnointerest.bind(this)
    this.AllLoanTypeList = this.AllLoanTypeList.bind(this)
    this.allCollectionagent = this.allCollectionagent.bind(this)
  }

  fetchBAData = async () => {
    try {
      const companyId  = getSecureItem("loggedinUserCompany");
 
      const data = {
        companyId,
        searchQuery: "",
      };
 
      const resp = await getAllBankAccountsDataAPI(data);
 
      if (resp?.data?.length > 0) {
        this.setState({ bankAccountData: resp.data, accountId: resp.data?.[resp.data?.length-1]?.accountId });
      }
    } catch (error) {
      console.error(error);
    }
  };
 
  getFilteredAccounts = () => {
    const { bankAccountData } = this.state;
 
    const accountsSelectData = [
      ...bankAccountData.map((item) => ({
        label: item.bankName,
        value: item.accountId,
      })),
      ...this.optionsOfAccount,
    ];
 
    const uniqueAccounts = accountsSelectData.reduce((acc, item) => {
      if (
        !acc.has(item.label) ||
        (acc.has(item.label) && acc.get(item.label).value === "0000")
      ) {
        acc.set(item.label, item);
      }
      return acc;
    }, new Map());
 
    return Array.from(uniqueAccounts.values());
  };
 
  getAccountsFilterData = () => {
    return this.state.bankAccountData.map((item) => ({
      label: item.bankName,
      value: item.accountId,
    }));
  };
 
  handleAccountChange = (event) => {
    const selectedValue = event.target.value;

    console.log({selectedValue});
    
    const selectedOption = this.getFilteredAccounts().find(
      (item) => item.value === selectedValue
    );

    console.log({selectedOption});

    if (selectedValue === "0000") {
      console.log("if");
      
      this.setState({
        labelOfBank: selectedOption?.label,
        accountId: selectedValue,
        error: "",
      });
    } else {
      console.log("else");
      this.setState({
        labelOfBank: "",
        accountId: selectedValue,
        error: "",
      });
    }
  };

  resolveAccountId = async () => {
    const { labelOfBank, accountId } = this.state;
    const userId  = getSecureItem("userid");
    const companyId  = getSecureItem("loggedinUserCompany");

    console.log("resolve", labelOfBank, accountId);
 
    if (labelOfBank) {
      const bankAccountPayload = {
        code: "0000",
        bankName: labelOfBank,
        companyId,
        createdByUserId: userId,
        updatedByUserId: userId,
      };
 
      const bankRes = await addBankAccountAPI(bankAccountPayload);
 
      console.log({bankRes});
      if (bankRes?.status === 200) {
        const newAccountId = bankRes.data?.result?.accountId;
        this.setState({ labelOfBank: "", accountId: newAccountId });
        this.fetchBAData();
        return newAccountId;
      }

      return accountId;
    }
 
    return accountId;
  };

  searchSubmit = (e) => {
    const value = typeof e === "string" ? e : e?.target?.value;

    this.setState({
      selectedBrand: value,
      isdisabled: true,
      rows: [],
    });

    const tenureMap = {
      "One Time": {
        tenure: "onetime",
        onetime: "",
        days: "none",
        weeks: "none",
        months: "none",
      },
      Monthly: {
        tenure: "monthly",
        onetime: "none",
        days: "none",
        weeks: "none",
        months: "",
      },
      Weekly: {
        tenure: "weekly",
        onetime: "none",
        days: "none",
        weeks: "",
        months: "none",
      },
      "Bi-Weekly": {
        tenure: "biweekly",
        onetime: "none",
        days: "none",
        weeks: "",
        months: "none",
      },
      Daily: {
        tenure: "daily",
        onetime: "none",
        days: "",
        weeks: "none",
        months: "none",
      },
      Ten_Daily: {
        tenure: "ten_daily",
        onetime: "none",
        days: "",
        weeks: "none",
        months: "none",
      },
      default: {
        tenure: "daily",
        onetime: "none",
        days: "",
        weeks: "none",
        months: "none",
      },
    };

    const valueToBrandMap = {
      onetime: "One Time",
      monthly: "Monthly",
      weekly: "Weekly",
      biweekly: "Bi-Weekly",
      daily: "Daily",
      ten_daily: "Ten_Daily",
    };
    const isFromParams = this.props.location?.params?.loanType || this.state.selectedLoanType;
    this.setState({
      installment:
        this.state.Entrylaontype == 'Balloon Method'
          ? Math.round(
            (Number(this.state.distamount) * Number(this.state.roiBM)) / 100
          ).toString()
          : this.returnInstallment(
            isFromParams
              ? Number(this.state.totalAmount)
              : this.calculateTotalAmount(
                parseInt(this.state.distamount),
                parseInt(this.state.fixedRoi),
                parseInt(this.state.loantenure),
                tenureMap[value]?.tenure
              ),
            this.state.loantenure
          ),
      totalAmount: isFromParams ? this.state.totalAmount : this.calculateTotalAmount(parseInt(this.state.distamount), parseInt(this.state.fixedRoi), parseInt(this.state.loantenure), tenureMap[value]?.tenure) });
    this.setState(tenureMap[value] || tenureMap.default);

    this.handleDateCreatedChange(this.state.createdAt);
    setTimeout(() => {
      this.handleDateCreatedChange(this.state.createdAt);
    }, 100);
  };
  
  allCollectionagent() {
    let companyId = getSecureItem("loggedinUserCompany")
    const loggedinUser = getSecureItem("loggedinUser");
    const branchId = loggedinUser?.branchId || null;
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+ getSecureItem("token")
    }
    axios.get(BaseUrl + `/user/getAllCollectors?branchId=${loggedinUser?.userType == 'superAdmin' ? '' : (branchId || '')}&companyId=` + companyId, {
      headers: headers,
    }).then(resp => {
      if (resp.status === 200 || resp.status === 304) {
        this.setState({
          Collectors: getSecureItem("loggedinUserCompany") === "3310" ? resp.data?.filter((item) => item?.isActive === true && item?.userType === 'Collection Agent') : resp.data?.filter((item) => item?.isActive === true),

        })
      } else {
        toast.error("Please try again!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      }
    }).catch(err => {
      // if (err.request.status !== 200) {
      //   toast.error("Please try again!", {
      //     position: "top-center",
      //     autoClose: 2000,
      //     hideProgressBar: true,
      //     closeOnClick: true,
      //     pauseOnHover: false,
      //     draggable: true,
      //   });
      // }
    })
  }

  getAllFees = async () => {
    const companyId = getSecureItem("loggedinUserCompany");
    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    try {
      const result = await axios.get(
        `${BaseUrl}/feeDetails/getFeeDetails/${companyId}?status=Active`,
        { headers }
      );

      this.setState(
        { feedetails: result.data || [] },
        () => this.recalculateFeesFromLoanAmount()
      );

    } catch (err) {
      this.setState({ feedetails: [] });
    }
  };

  addFeeDetails = () => {
    this.props.history.push('/addFeeDetails?from=AddLoanWithoutInterest');
  };

  handleFeeValueChange = (event, fee) => {
    const loanAmount = Number(this.state.distamount || 0);
    let amount = 0;

    if (fee.calculation === "Fixed") {
      amount = Number(event.target.value || 0);
    } else if (fee.calculation === "Percentage") {
      amount = Number(event.target.value || 0);
    } else {
      amount = (loanAmount * Number(fee.value)) / 100;
    }

    this.setState(prev => {
      const updated = {
        ...prev.feeValues,
        [fee.name]: amount
      };

      const total = Object.values(updated)
        .reduce((sum, v) => sum + Number(v || 0), 0);

      updated.totalFee = total;

      return { feeValues: updated, totalFee: total };
    });
  };

  recalculateFeesFromLoanAmount = () => {
    const loanAmount = Number(this.state.distamount || 0);
    const updatedFees = {};

    this.state.feedetails.forEach(fee => {
      if (fee.calculation === "Percentage") {
        updatedFees[fee.name] = Math.round((loanAmount * Number(fee.value)) / 100 * 100) / 100; // Round to 2 decimals
      } else if (fee.calculation === "Fixed") {
        updatedFees[fee.name] = Math.round(Number(fee.value) * 100) / 100;
      }
    });

    const total = Object.values(updatedFees)
      .reduce((sum, v) => sum + Number(v || 0), 0);

    updatedFees.totalFee = Math.round(total * 100) / 100;

    this.setState({
      feeValues: updatedFees,
      totalFee: updatedFees.totalFee,
    });
  };

  getAllCalculatedFees = () => {
    const feeBreakdown = this.state.feedetails.map(fee => ({
      name: fee.name,
      value: fee.value,
      calculation: fee.calculation,
      calculatedAmount: this.state.feeValues[fee.name] || 0
    }));

    return {
      loanAmount: Number(this.state.distamount || 0),
      feeBreakdown: feeBreakdown,
      totalFees: this.state.totalFee || 0,
      totalAmountWithFees: (Number(this.state.distamount || 0) + (this.state.totalFee || 0))
    };
  };

  handleCustomerInputChange = (event, type) => {
    const value = event.target.value;

    this.setState({
      [`choose${type}`]: value,
      [`show${type}Dropdown`]: false,
      [`all${type}`]: [],
      isdisabled: true,
      rows: [],
    });

    if (!value.trim()) {
      this.setState({ [`choose${type}`]: "" });
    }
  };

  triggerCustomerSearch = (type) => {
    const loggedinUser = getSecureItem("loggedinUser");
    const value = (this.state[`choose${type}`] || "").trim();

    this.setState({
      [`show${type}Dropdown`]: false,
      [`all${type}`]: [],
      isdisabled: true,
      rows: [],
    });

    if (!value) {
      this.setState({ [`choose${type}`]: "" });
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getSecureItem("token"),
    };

    axios
      .get(
        `${BaseUrl}/customer/getVerifiedCustomers?name=${value}&companyId=${loggedinUser.companyId}&branchId=${loggedinUser?.userType === "superAdmin" ? "" : loggedinUser.branchId || ""}`,
        { headers }
      )
      .then((resp) => {
        if (resp.status === 200) {
          this.setState({
            [`all${type}`]: resp.data,
            [`show${type}Dropdown`]: resp.data.length > 0,
          });
          if (resp.data.length <= 0) {
            this.setState({ [`choose${type}`]: "" });
          }
        } else {
          toast.error("Please try again!");
        }
      });
  };

  selectName = (selectedData, type) => {
    if (type === "Borrower") {
      this.setState({
        chooseBorrower: selectedData.cust_id
          ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
          : `${selectedData.firstName} ${selectedData.lastName}`,
        customerId: selectedData.customerId, // <-- Ensure this is set!
        showBorrowerDropdown: false,
        isdisabled: true,
        rows: [],
        searchdoneBorrower: false,
      });
    } else if (type === "CoApplicant") {
      this.setState({
        chooseCoApplicant: selectedData.cust_id
          ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
          : `${selectedData.firstName} ${selectedData.lastName}`,
        coApplicantCustomerId: selectedData.customerId,
        showCoApplicantDropdown: false,
        isdisabled: true,
        rows: [],
        searchdoneCoApplicant: false,
      });
    } else if (type === "Guarantor") {
      this.setState({
        chooseGuarantor: selectedData.cust_id
          ? `${selectedData.firstName} ${selectedData.lastName} (${selectedData.cust_id})`
          : `${selectedData.firstName} ${selectedData.lastName}`,
        guarantorCustomerId: selectedData.customerId,
        showGuarantorDropdown: false,
        isdisabled: true,
        rows: [],
        searchdoneGuarantor: false,
      });
    }
  };

  renderDropdown = (data, type) => {
    return data.length > 0 && this.state[`show${type}Dropdown`] ? (
      <div
        style={{
          position: "absolute",
          top: "calc(100% + 6px)",
          left: 0,
          width: "100%",
          background: "#fff",
          border: "1px solid #E5E7EB",
          borderRadius: "8px",
          boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
          maxHeight: "260px",
          overflowY: "auto",
          zIndex: 9999,
        }}
      >
        {data.map((option) => (
          <div
            key={option.customerId || option.cust_id}
            onMouseDown={() => this.selectName(option, type)}
            style={{
              padding: "10px 14px",
              cursor: "pointer",
              borderBottom: "1px solid #F3F3F3",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#F4F7FF";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "#FFF";
            }}
          >
            <div
              style={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#212121",
              }}
            >
              {option.firstName} {option.lastName}
            </div>

            <div
              style={{
                marginTop: "2px",
                fontSize: "12px",
                color: "#8C8C8C",
              }}
            >
              {option.cust_id}
              {option.phone ? ` • ${option.phone}` : ""}
            </div>
          </div>
        ))}
      </div>
    ) : (
      this.state[`searchdone${type}`] && (
        <div
          style={{
            color: "#d32f2f",
            fontSize: "12px",
            marginTop: "4px",
          }}
        >
          Choose a valid {type?.toLowerCase()}
        </div>
      )
    );
  };

  componentDidMount() {
    if (this.props.location.params) {
      if (this.props.location.params.loanType) {
        this.setState({
          // customerId: this.props.location.params.customerId,
          // chooseBorrower: this.props.location.params.firstName,
          loanTypeId:this.props.location.params.loanTypeId,
          laontype: this.props.location.params.loanType,
          amountfrom: this.props.location.params.loanAmtRangeFrom,
          amountto: this.props.location.params.loanAmtRangeTo,
          fixedRoi: this.props.location.params.fixedRoi,
          selectedBrand: this.props.location.params.fixedLoanTenureType,
          loantenure: this.props.location.params.fixedLoanDuration,
          distamount: this.props.location.params.fixedLoanAmount,
          processFee: this.props.location.params.fixedProcessingFee,
          totalAmount: this.props.location.params.fixedLoanCollectedAmount,
          onetimefrom:1,
          onetimeto:1,
          daysfrom: this.props.location.params.tenureDaysFrom,
          daysto: this.props.location.params.tenureDaysTo,
          weeksfrom: this.props.location.params.tenureWeeksFrom,
          weeksto: this.props.location.params.tenureWeeksTo,
          monthsfrom: this.props.location.params.tenureMonthsFrom,
          monthsto: this.props.location.params.tenureMonthsTo,
          path: "Loan Type",
          rows:[],
          collectionagent:"",
          searchdone:false
          // choosecustmr:"none"

        }, () => {
          this.searchSubmit(this.props.location.params.fixedLoanTenureType);
          this.recalculateFeesFromLoanAmount();
        })
      } else if (this.props.location.params.customerId) {
        const {
          customerId,
          replan,
          cust_id,
          name,
          firstName,
          lastName,
          loanType
        } = this.props.location.params; 
        this.setState({
          customerId: customerId,
          chooseBorrower: replan ? (cust_id ? `${name} (${cust_id})` : name)  : (cust_id ? `${firstName} ${lastName} (${cust_id})` : `${firstName} ${lastName}`),
          laontype: loanType,
          path: "New Customer",
          rows:[],
          collectionagent:"",
          searchdone:false

          // choosecustmr:"none"
        })
      } else if (this.props.location.params.midReplan) {
        this.setState({
          path: "Replan Loan",
          rows: [],
          collectionagent: "",
          searchdone: false,
        });
      }

      if(this.props.location.params?.replan){
       const {tenureTypeR, loanTypeR, amountGivenR, amountToCollectR} = this.props.location.params;
        
       this.setState({
          distamount: amountGivenR,
          totalAmount: amountToCollectR
        });
        setTimeout(() => {
          this.LoanChange(loanTypeR);
          this.searchSubmit(tenureTypeR)
        }, 1000);
      }
    } else {
      this.setState({
        path: "Loans",
        collectionagent:"",
        rows:[],
        searchdone:false
      })
    }
    this.setState({
      tenure: "onetime",
      userId: getSecureItem('userid'),
      rows:[],
      collectionagent:"",
      searchdone:false
    })
    this.AllLoanTypeList(() => {
      if (this.props.location?.params?.midReplan) {
        this.applyReplanLoanDetails(this.props.location.params.loanDetails,this.props.location.params.previousOverDueAmount,this.props.location.params.previousLoanId);
      }
    });

    this.allCollectionagent();
    this.getAllFees();
    this.fetchBAData();
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  reverseTenureTypeMap = {
    onetime: "One Time",
    monthly: "Monthly",
    weekly: "Weekly",
    biweekly: "Bi-Weekly",
    daily: "Daily",
    ten_daily: "Ten_Daily",
  };

  applyReplanLoanDetails = (loanDetails,previousOverDueAmount,previousLoanId) => {
    if (!loanDetails) return;

    const customer = loanDetails.customer || {};
    const matchedLoanType = this.state.LaonType.find(
      (item) => item.loanTypeId === loanDetails.loanTypeId
    );

    const tenureType = (loanDetails.loanTenureType || "").toLowerCase();
    const brandName = this.reverseTenureTypeMap[tenureType] || "Daily";
    const isBalloon =
      loanDetails.method !== "Collection method" && loanDetails.method !== "EMI Method";

    let entryType;

    switch (loanDetails.method) {
      case "EMI Method":
        entryType = "EMI Method";
        break;

      case "Balloon Method":
        entryType = "Balloon Method";
        break;

      case "Flexi EMI":
        entryType = "Flexi EMI";
        break;

      case "Collection method":
      default:
        entryType = "Collection method";
        break;
    }

    const buttonFlags =
      entryType !== "Collection method"
        ? { calInterest: "", InterestButtonAction: "", ButtonAction: "none" }
        : { calInterest: "none", InterestButtonAction: "none", ButtonAction: "" };

    const feeValues = loanDetails.feeDetailsJson || {};
    const totalFee = Object.values(feeValues).reduce(
      (sum, v) => sum + Number(v || 0),
      0
    );

    this.setState(
      {
        // loanTypeId: loanDetails.loanTypeId,
        // laontype: matchedLoanType ? matchedLoanType.loanType : "",
        // amountfrom: matchedLoanType?.loanAmtRangeFrom ?? "0",
        // amountto: matchedLoanType?.loanAmtRangeTo ?? "0",
        // fixedRoi: matchedLoanType?.fixedRoi ?? "0",
        // daysfrom: matchedLoanType?.tenureDaysFrom ?? "0",
        // daysto: matchedLoanType?.tenureDaysTo ?? "0",
        // weeksfrom: matchedLoanType?.tenureWeeksFrom ?? "0",
        // weeksto: matchedLoanType?.tenureWeeksTo ?? "0",
        // monthsfrom: matchedLoanType?.tenureMonthsFrom ?? "0",
        // monthsto: matchedLoanType?.tenureMonthsTo ?? "0",

        Entrylaontype: entryType,
        // typeOfBM: isBalloon ? loanDetails.method : "interestOnly",
        // roiBM: isBalloon ? loanDetails.rateOfInterest || "" : "",

        // selectedBrand: brandName,
        // tenure: tenureType,
        // loantenure: loanDetails.loanTenure,
        // distamount: loanDetails.loanAmount,
        // totalAmount: loanDetails.totalAmountToCollect,
        // installment: loanDetails.collectionAmount,
        // processFee: loanDetails.processFee || 0,
        // penalty: loanDetails.penalty || "",
        ...buttonFlags,
        previousOverDueAmount: previousOverDueAmount,
        previousLoanId: previousLoanId,

        // whenNotPaid: loanDetails.Accumulate || "",
        // autoUpdateNPD: loanDetails.autoUpdate || "No",

        // feeValues,
        // totalFee,

        customerId: loanDetails.customerId,
        coApplicantCustomerId: loanDetails.coApplicantCustomerId || null,
        guarantorCustomerId: loanDetails.guarantorCustomerId || null,
        chooseBorrower: customer.cust_id
          ? `${customer.firstName} ${customer.lastName} (${customer.cust_id})`
          : `${customer.firstName || ""} ${customer.lastName || ""}`.trim(),

        isdisabled: true,
        rows: [],
      },
      () => {
        this.getAllFees();
      }
    );
  };

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.borrowerWrapperRef?.current && !this.borrowerWrapperRef.current.contains(event.target)) {
      this.setState({ showBorrowerDropdown: false });
    }
    if (this.coApplicantWrapperRef?.current && !this.coApplicantWrapperRef.current.contains(event.target)) {
      this.setState({ showCoApplicantDropdown: false });
    }
    if (this.guarantorWrapperRef?.current && !this.guarantorWrapperRef.current.contains(event.target)) {
      this.setState({ showGuarantorDropdown: false });
    }
  };
  _handleSubmit(e) {
    e.preventDefault();
    // TODO: do something with -> this.state.file
  }


  handleChange = event => {
    this.setState({ category: event.target.value,
      isdisabled:true,rows:[]});
    // this.setState({ vehiclemodel: event.target.value })
  };
  nameBox() {
    this.setState({
      changeColorname: "1px solid #00D95E",
      changeColornumber: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5"
    })
  }
  numberBox() {
    this.setState({
      changeColornumber: "1px solid #00D95E",
      changeColorname: "1px solid #D4D4D5",
      changeColoremail: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5"
    })
  }
  emailBox() {
    this.setState({
      changeColoremail: "1px solid #00D95E",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #D4D4D5',
      annual1: '1px solid #D4D4D5'
    })
  }
  emailBox1() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #00D95E",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #D4D4D5',
      annual1: '1px solid #D4D4D5'
    })
  }
  emailBox2() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #00D95E",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #D4D4D5',
      annual1: '1px solid #D4D4D5'
    })
  }
  emailBox3() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #00D95E",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #D4D4D5',
      annual1: '1px solid #D4D4D5'
    })
  }
  emailBox4() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #00D95E",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #D4D4D5',
      annual1: '1px solid #D4D4D5'
    })
  }
  emailBox5() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #00D95E",
      changeColoremail6: "1px solid #D4D4D5",
      changeColoremail7: "1px solid #D4D4D5",
      showBorrowerDropdown: true,
      showCoApplicantDropdown: false,
      showGuarantorDropdown: false,
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: "1px solid #D4D4D5",
      annual1: "1px solid #D4D4D5",
    });
  }
  emailBox6() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColoremail6: "1px solid #00D95E",
      changeColoremail7: "1px solid #D4D4D5",
      showBorrowerDropdown: false,
      showCoApplicantDropdown: true,
      showGuarantorDropdown: false,
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: "1px solid #D4D4D5",
      annual1: "1px solid #D4D4D5",
    });
  }
  emailBox7() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColoremail6: "1px solid #D4D4D5",
      changeColoremail7: "1px solid #00D95E",
      showBorrowerDropdown: false,
      showCoApplicantDropdown: false,
      showGuarantorDropdown: true,
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: "1px solid #D4D4D5",
      annual1: "1px solid #D4D4D5",
    });
  }
  annualBox() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #00D95E',
      annual1: '1px solid #D4D4D5'
    })
  }
  annualBox1() {
    this.setState({
      changeColoremail: "1px solid #D4D4D5",
      changeColoremail1: "1px solid #D4D4D5",
      changeColoremail2: "1px solid #D4D4D5",
      changeColoremail3: "1px solid #D4D4D5",
      changeColoremail4: "1px solid #D4D4D5",
      changeColoremail5: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
      changeColorcategory: "1px solid #D4D4D5",
      annual: '1px solid #D4D4D5',
      annual1: '1px solid #00D95E'
    })
  }
  categoryBox() {
    this.setState({
      changeColorcategory: "1px solid #00D95E",
      changeColoremail: "1px solid #D4D4D5",
      changeColornumber: "1px solid #D4D4D5",
      changeColorname: "1px solid #D4D4D5",
    })
  }
  backLinkAction() {
    // this.props.history.push('/allnewcustomers')
    window.history.back()
  }
  handleDateChange = (date) => {
    this.setState({
      SelectedDate: date,
      isdisabled:true,
      rows:[]
    })
  };

  getNextDueDate(startDate, tenure) {
    if (!(startDate instanceof Date) || isNaN(startDate)) {
      throw new Error("Invalid start date provided.");
    }
  
    const nextDate = new Date(startDate); // clone so we don't mutate original
  
    switch (tenure?.toLowerCase()) {
      case "onetime":
        // Return the same date
        break;
  
      case "daily":
        nextDate.setDate(nextDate.getDate() + 1);
        break;

      case "ten_daily":
        nextDate.setDate(nextDate.getDate() + 10);
        break;
  
      case "weekly":
        nextDate.setDate(nextDate.getDate() + 7);
        break;
  
      case "biweekly":
        nextDate.setDate(nextDate.getDate() + 14);
        break;
  
      case "monthly":
        nextDate.setMonth(nextDate.getMonth() + 1);
        break;
  
      default:
        throw new Error("Invalid tenure provided.");
    }
  
    return nextDate;
  }

  handleDateCreatedChange = (date) => {
    const updatedDate = this.getNextDueDate(date, this.state.tenure);
    this.setState({
      createdAt: date,
      SelectedDate: updatedDate,
      isdisabled:true,
      rows:[]
    })
  };

  handleInputChange = (event) => {
    this.setState({
      amountvalues: event.target.value === '' ? '' : Number(event.target.value),
      isdisabled:true,
      rows:[]
    })
    // setValue(event.target.value === '' ? '' : Number(event.target.value));
  };
  handleSliderChange = (event, newValue) => {
    this.setState({
      amountvalues: newValue,
      isdisabled:true,
      rows:[]
    })
    
    // setValue(newValue);
  };

  handleSlidertenureChange = (event, newValue) => {
    this.setState({
      tenurevalues: newValue,
      isdisabled:true,
      rows:[]
    })

  }
  handleInputtenureChange = event => {
    this.setState({
      tenurevalues: event.target.value === '' ? '' : Number(event.target.value),
      isdisabled:true,
      rows:[]
    })

  }
  handleInputinterestChange = event => {
    this.setState({
      interestvalues: event.target.value === '' ? '' : Number(event.target.value),
      isdisabled:true,
      rows:[]
    })

  }
  handleSliderinterestChange = (event, newValue) => {
    this.setState({
      interestvalues: newValue,
      isdisabled:true,
      rows:[]
    })
  }
  AllLoanTypeList(callback = () => { }) {
    
const headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer '+ getSecureItem("token")
}
    let loggedinUser = getSecureItem("loggedinUserCompany")
    axios.get(BaseUrl + '/loanType/getAllLoanTypes?loanType=&companyId=' + loggedinUser, {
      headers: headers,
    }).then(resp => {
      if (resp.status === 200) {
        this.setState({ LaonType: resp.data }, callback);
      } else {
        toast.error("Please try again!", {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
        });
      }
    }).catch(err => {
      // if (err.request.status !== 200) {
      //   toast.error("Please try again!", {
      //     position: "top-center",
      //     autoClose: 2000,
      //     hideProgressBar: true,
      //     closeOnClick: true,
      //     pauseOnHover: false,
      //     draggable: true,
      //   });
      // }
    })
  }
  betweenRange = () => {
    if (this.state.chooseBorrower && this.state.customerId != "") {
    if ((this.state.distamount >= parseInt(this.state.amountfrom)) && (this.state.distamount <= parseInt(this.state.amountto))) {
      if (this.state.tenure === "monthly") {
        if (this.state.loantenure >= this.state.monthsfrom && this.state.loantenure <= this.state.monthsto) {
          // if(this.state.whenNotPaid == ""){
          //   toast.error("Please select When Not Paid", {
          //     position: "top-center",
          //     autoClose: 3000,
          //     hideProgressBar: true,
          //     closeOnClick: true,
          //     pauseOnHover: false,
          //     draggable: true,
          //   });
          // } else {
            this.calculationwithnointerest()
          // }
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "weekly") {
        if (this.state.loantenure >= this.state.weeksfrom && this.state.loantenure <= this.state.weeksto) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "biweekly") {
        if (this.state.loantenure >= this.state.weeksfrom && this.state.loantenure <= this.state.weeksto) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "onetime") {
        if (this.state.loantenure === "1") {
          this.calculationwithnointerest()
        } else {
          console.log("Entered one time")
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      }
      else if (this.state.tenure === "daily") {
        if (this.state.loantenure >= this.state.daysfrom && this.state.loantenure <= this.state.daysto) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      } else if (this.state.tenure === "ten_daily") {
        if (this.state.loantenure >= this.state.daysfrom && this.state.loantenure <= this.state.daysto) {
          this.calculationwithnointerest()
        } else {
          toast.error("Loan Duration must be in range", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
          });
        }
      }
    } else {
      toast.error("Loan Amount must be in range", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      });
    }
  }
  else{
      toast.error("Choose Borrower to Assign Loan!!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
    });
  }
}

  calculateTotalAmount(principal, roi, tenure, tenureType = "monthly") {
    let tenureInYears;

    switch (tenureType?.toLowerCase()) {
      case 'daily':
        tenureInYears = tenure / 365;
        break;
      case 'ten_daily':
        tenureInYears = tenure / 36.5;
        break;
      case 'weekly':
        tenureInYears = tenure / 52;
        break;
      case 'biweekly': // every 2 weeks
        tenureInYears = (tenure * 2) / 52;
        break;
      case 'monthly':
        tenureInYears = tenure / 12;
        break;
      default:
        tenureInYears = tenure / 12;
        break;
        // throw new Error('Invalid tenure type. Use daily, weekly, biweekly, or monthly.');
    }

    const interest = (principal * roi * tenureInYears) / 100;
    const totalAmount = principal + interest;

    return Math.round(parseFloat(totalAmount))
  }

  getInterestRateFromPeriodRate(loanTenureType, periodRate) {
    let periodsPerYear;

    switch (loanTenureType) {
      case "daily":
        periodsPerYear = 365;
        break;
      case "ten_daily":
        periodsPerYear = 36.5;
        break;
      case "weekly":
        periodsPerYear = 52;
        break;
      case "biweekly":
        periodsPerYear = 26;
        break;
      case "monthly":
        periodsPerYear = 12;
        break;
      default:
        throw new Error(`Invalid loan tenure type: ${loanTenureType}`);
    }

    const rateOfInterest = periodRate * periodsPerYear; // Annual ROI
    return rateOfInterest;
  }

  calculationwithnointerest() {
    let loggedinUser = getSecureItem("loggedinUser")
    this.state.userdetails = {
      "loanTypeId": this.state.loanTypeId,
      "method": this.state.Entrylaontype == 'Balloon Method' ? this.state.typeOfBM : "Collection method",
      "penalty": parseInt(this.state.penalty) || 0,
      "loanAmount": parseInt(this.state.distamount),
      "loanTenureType": this.state.tenure,
      "loanTenure": parseInt(this.state.loantenure),
      "collectionAmount": parseInt(this.state.installment),
      "nextDueDate":this.state.SelectedDate,
      "startDate": this.state.SelectedDate,
      "createdAt": this.state.createdAt,
      // "totalAmountToCollect": this.state.Entrylaontype == 'Balloon Method' ? this.calculateTotalAmount(parseInt(this.state.distamount), this.getInterestRateFromPeriodRate(this.state.tenure, Number(this.state.roiBM)), parseInt(this.state.loantenure)-1, this.state.tenure) : (this.state.totalAmount || 0),
      "totalAmountToCollect": this.state.Entrylaontype == 'Balloon Method' ? parseInt(this.state.distamount || "0") : parseInt(this.state.totalAmount || "0"),
      "processFee": parseInt(this.state.processFee || "0"),
      "feeDetailsJson": {...this.state.feeValues},
      "Accumulate": this.state.whenNotPaid,
      "autoUpdate": this.state.autoUpdateNPD,
      "createdByUserId": parseInt(this.state.userId),
      "updatedByUserId": parseInt(this.state.userId),
      "customerId": this.state.customerId,
      coApplicantCustomerId: this.state.coApplicantCustomerId || null,
      guarantorCustomerId: this.state.guarantorCustomerId || null,
      loanStatus: "Open",
      "createdByUserId": getSecureItem("userid"),
      "updatedByUserId": getSecureItem("userid"),
      "companyId": loggedinUser.companyId,
      ...(this.state.Entrylaontype == 'Balloon Method' && {
          rateOfInterest: this.state.roiBM ? Number(this.state.roiBM) : "" ,
          balloonPercent: Number(this.state.lastEmiPercentageBM) || 0,
        })
    }    
const headers = {
  'Content-Type': 'application/json',
  'Authorization': 'Bearer '+ getSecureItem("token")
}
    const url = this.state.Entrylaontype === "Balloon Method" ? "/loan/calculateBalloon" : "/loan/calculate";
    axios.post(BaseUrl + url, this.state.userdetails, {
      headers: headers,
    }).then(resp => {
      this.state.scheduleArr = resp.data.map((item) => ({
        ...item,
        openingBalance: item.openingBalance,
        scheduledDate: item.scheduledDate,
        loanTenure: parseInt(this.state.loantenure),
        closingBalance: item.closingBalance,
        collectionAmount: item.collectionAmount,
        // collectorId: this.state.collectionagent,
        createdByUserId: parseInt(this.state.userId),
        updatedByUserId: parseInt(this.state.userId),
        customerId: this.state.customerId,
        "companyId": loggedinUser.companyId
      }))

      this.state.collectionArr = resp.data.map((item, index) => (
        {
          dueDate: item.scheduledDate,
          nextSchedule: resp.data.length === (index + 1) ? resp.data[index].scheduledDate : resp.data[(index + 1)].scheduledDate,
          Installment: item.collectionAmount,
          collectionAmount: item.collectionAmount,
          openingBalance: item.openingBalance,
          closingBalance: item.closingBalance,
          collectionStatus: null,
          PenaltyApplied: null,
          // openingBalance: item.openingBalance,
          // closingBalance: item.closingBalance,

          // collectorId: this.state.collectionagent,
          createdByUserId: parseInt(this.state.userId),
          updatedByUserId: parseInt(this.state.userId),
          customerId: this.state.customerId ? this.state.customerId : '',
          "companyId": loggedinUser.companyId

        }
      ))
      if (resp.request.status === 200) {
        this.setState({
          rows: this.state.scheduleArr,
          isdisabled:false,
                  })
      } else {

      }
    }).catch(err => {
      if (err.response.status === 400)
      {
      toast.error("Loan Repayment Amount is less than Loan Amount!!!,"+"\n"+"Please enter correct data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,  
      });
    }
    else
    {
      toast.error("Please try again!!", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
      }); 
    }
    })
    this.setState({
      // totalAmount: this.state.Entrylaontype === "Balloon Method" ? this.calculateTotalAmount(parseInt(this.state.distamount), this.getInterestRateFromPeriodRate(this.state.tenure, Number(this.state.roiBM)), parseInt(this.state.loantenure)-1, this.state.tenure) : this.state.totalAmount,
      totalAmount: this.state.Entrylaontype === "Balloon Method" ? this.state.installment : this.state.totalAmount,
      isdisabled:false
    })
  }
  async postLoannoInterest() {
    const resolvedAccountId = await this.resolveAccountId();
    this.setState({
      isdisabled: true
    });
    if (this.state.chooseBorrower && this.state.collectionagent) {
    this.state.userdetails.loanSchedules = this.state.scheduleArr;
    this.state.userdetails.loancollections = this.state.collectionArr;
    this.state.userdetails.collectorId = this.state.collectionagent;
    this.state.userdetails.loanPaymentStatus = "Due";
    // this.state.userdetails.previousLoanAmount= this.state.previousOverDueAmount;
    // this.state.userdetails.previousLoanId= this.state.previousLoanId;
    this.state.userdetails.processFee = this.state.processFee;
    this.state.userdetails.feeDetailsJson = {...this.state.feeValues};
    this.state.userdetails.Accumulate = this.state.whenNotPaid;
    this.state.userdetails.accountId = resolvedAccountId;
    this.state.userdetails.autoUpdate = this.state.autoUpdateNPD;
    this.state.userdetails.coApplicantCustomerId =
      this.state.coApplicantCustomerId || null;
    this.state.userdetails.guarantorCustomerId =
      this.state.guarantorCustomerId || null;
    this.state.userdetails.loancollections.forEach((item, index) => {
    this.state.userdetails.loanSchedules[index].collectorId = this.state.collectionagent;
    this.state.userdetails.loancollections[index].collectorId = this.state.collectionagent;
    })

    if(this.props.location.params?.loanIdR){
      let obj = {
        loanStatus: "Closed",
        cancellationReason: "Replanning loan",
        loanId: this.props.location.params?.loanIdR,
  
      };
      await fetchAPIData("cancelLoan", obj);
    }

    const LoanSettings = getSecureItem("LoanSettings");
    if(LoanSettings?.autoApprove){
      this.state.userdetails.approvalDate = this.state.createdAt;
      this.state.userdetails.disbursedDate = this.state.createdAt;
    }

    if(this.props.location?.params?.midReplan){
      this.state.userdetails.lastCollectedDate = this.props.location?.params?.closingDate;
      this.state.userdetails.updatedAt = this.props.location?.params?.closingDate;
      this.state.userdetails.previousLoanAmount = this.props.location?.params?.loanDetails?.totalReplanAmount;
      this.state.userdetails.previousLoanId = this.props.location?.params?.previousLoanId;
    }

      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getSecureItem("token"),
      };
      axios
        .post(BaseUrl + "/loan/postLoan", this.state.userdetails, {
          headers: headers,
        })
        .then((res) => {
          if (res.request.status === 200) {
            // {this.state.chooseBorrower}
            let custname = this.state.chooseBorrower;
            let laontype = this.state.laontype;

            if (res.data?.loanId) {
              toast.success(
                laontype + " " + "Assigned Successfully to" + " " + custname,
                {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: true,
                }
              );

            const LoanSettings = getSecureItem("LoanSettings");
            if(LoanSettings?.autoApprove){
              this.props.history.push("/customer");
            } else {
              this.props.history.push("/loandisbursement");
            }
          } else {
            // Alert.alert("Warning", res.data?.message)
            toast.error(res.data?.message, {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
            });
            this.props.history.push("/customer");

          }
          this.setState({isdisabled: false})
      }
    })
  }
  else{
    if(this.state.collectionagent)
    {
    toast.error("Choose Borrower to Assign Loan!!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
    })
  }
  else
  {
    toast.error("Assign to a Collection Agent!!", {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
    })
  }
  }
  }
  cancel() {
    //this.props.history.push("/")
    window.history.back()
  }
  collectionangentChange(event) {
    this.setState({ collectionagent: event.target.value });
  }
  clear() {
    const { brands } = this.state;
    console.log({brands});
    this.setState({
      SelectedDate: new Date(),
      createdAt: new Date(),
      brands: [{ id: 1, name: "One Time" },{ id: 2, name: "Monthly" }, { id: 3, name: "Weekly" }, { id: 3, name: "Bi-Weekly" }, { id: 4, name: "Daily" }],
      rows: [],
      totalAmount: "",
      loantenure: "",
      installment: "",
      distamount: "",
      laontype: "",
      penalty: "",
      chooseBorrower: "",
      amountfrom: "0",
      amountto: "0",
      fixedRoi: "0",
      daysfrom: "0",
      daysto: "0",
      weeksfrom: "0",
      weeksto: "0",
      monthsfrom: "0",
      monthsto: "0",
      Entrylaontype: "Collection method",
      collectionArr: [],
      scheduleArr: [],
      collectionagent:"",
      tenure: "onetime",
      //tenure: "",
      days: "none",
      weeks: "none",
      months: "none",
      onetime:"",
      userId: getSecureItem('userid'),
      isdisabled:true,
      searchdone:false
    })
  }
  checking() {
    this.setState({ afterSelect: "none" })
  }
  LoanChange = (event) => {
    const value = typeof event === "string" ? event : event?.target?.value;
  
    const selectedLoanType = this.state.LaonType.find(
      (item) => item.loanType === value
    );
  
    const baseState = {
      laontype: value,
      isdisabled: true,
      rows: [],
    };
  
    const detailState = selectedLoanType
      ? {
          loanTypeId: selectedLoanType.loanTypeId,
          amountfrom: selectedLoanType.loanAmtRangeFrom,
          amountto: selectedLoanType.loanAmtRangeTo,
          fixedRoi: selectedLoanType.fixedRoi,
          onetimefrom: 1,
          onetimeto: 1,
          daysfrom: selectedLoanType.tenureDaysFrom,
          daysto: selectedLoanType.tenureDaysTo,
          weeksfrom: selectedLoanType.tenureWeeksFrom,
          weeksto: selectedLoanType.tenureWeeksTo,
          monthsfrom: selectedLoanType.tenureMonthsFrom,
          monthsto: selectedLoanType.tenureMonthsTo,
          selectedBrand: selectedLoanType.fixedLoanTenureType,
          loantenure: selectedLoanType.fixedLoanDuration,
          distamount: selectedLoanType.fixedLoanAmount,
          processFee: selectedLoanType.fixedProcessingFee,
          totalAmount: selectedLoanType.fixedLoanCollectedAmount,
        }
      : {};
  
    this.setState(
      {
        selectedLoanType: value,
        ...baseState,
        ...detailState,
      },
      () => {
        this.recalculateFeesFromLoanAmount()
        if (selectedLoanType?.fixedLoanTenureType) {
          this.searchSubmit(selectedLoanType.fixedLoanTenureType);
        }
      }
    );
  };  
  TableData=(rows,collectionagent,isdisabled)=>{
    console.log("parent row",rows)
    this.setState({
      rows:rows,
      collectionagent:collectionagent,
      isdisabled:isdisabled
    })
  }
  // componentWillReceiveProps=(nextProps)=>{
  //   console.log("nextProps",nextProps)
  //   this.setState({
  //     rows:nextProps.rows
  //   })
  // }
  EntryLoanTypeChange = (event) => {
    this.setState({
      Entrylaontype: event.target.value,
      isdisabled:true,
      rows:[]
    })
    if(event.target.value !== "Collection method"){
      this.setState({
        calInterest:"",
        InterestButtonAction:"",
        ButtonAction:"none"
      })
    } else {
      this.setState({
        calInterest:"none",
        InterestButtonAction:"none",
        ButtonAction:""
      })
    }
  }
  postLoanInterest=()=>{
    this.child.postLoan() 
  }

  returnInstallment(totalAmount, loantenure) {
      totalAmount = parseFloat(totalAmount);
      loantenure = parseFloat(loantenure);

      return Math.round(totalAmount/loantenure);
    }

  render() {
    const LoanSettings = getSecureItem("LoanSettings");
    const currency = getSecureItem("country")?.symbol;
    let countryCurrencySymbol = currency;  
    const { t } = this.props;

  

    function checkLoanTenure(onetimefrom, onetimeto, daysfrom, daysto, weeksfrom, weeksto, monthsfrom, monthsto, loantenure, tenure) {
      // Convert string values to numbers
      onetimefrom = parseFloat(onetimefrom);
      onetimeto = parseFloat(onetimeto);
      daysfrom = parseFloat(daysfrom);
      daysto = parseFloat(daysto);
      weeksfrom = parseFloat(weeksfrom);
      weeksto = parseFloat(weeksto);
      monthsfrom = parseFloat(monthsfrom);
      monthsto = parseFloat(monthsto);
      loantenure = parseFloat(loantenure);
  
      if (tenure == "onetime") {
        if(loantenure >= onetimefrom && loantenure <= onetimeto){
          return "none";
        } else {
          return "block";
        }
      } else if (tenure == "daily") {
        if(loantenure >= daysfrom && loantenure <= daysto){
          return "none";
        } else {
          return "block";
        }
      } else if (tenure == "ten_daily") {
        if(loantenure >= daysfrom && loantenure <= daysto){
          return "none";
        } else {
          return "block";
        }
      } else if (tenure == "weekly") {
        if(loantenure >= weeksfrom && loantenure <= weeksto){
          return "none";
        } else {
          return "block";
        }
      } else if (tenure == "biweekly") {
        if(loantenure >= weeksfrom && loantenure <= weeksto){
          return "none";
        } else {
          return "block";
        }
      } else if (tenure == "monthly") {
        if(loantenure >= monthsfrom && loantenure <= monthsto){
          return "none";
        } else {
          return "block";
        }
      }
    }

    function checkAmountRange(amountfrom, amountto, amount) {
      // Convert string values to numbers
      amountfrom = parseFloat(amountfrom);
      amountto = parseFloat(amountto);
  

        if(amount >= amountfrom && amount <= amountto){
          return "none";
        } else {
          return "block";
        }
    }

    

    const {onetime, days, weeks, months, onetimefrom, onetimeto, daysfrom, daysto, weeksfrom, weeksto, monthsfrom, monthsto, tenure, loantenure, amountfrom, amountto, fixedRoi, distamount, totalAmount, whenNotPaid, autoUpdateNPD, typeOfBM, roiBM, lastEmiPercentageBM, accountId } = this.state;

    toast.configure({});
    const { brands, selectedBrand, isdisabled, searchdone } = this.state;
    const filteredDataAccounts = this.getFilteredAccounts();
    function getPeriodRate(loanTenureType, rateOfInterest) {
      let periodsPerYear;

      switch (loanTenureType) {
        case "daily":
          periodsPerYear = 365;
          break;
        case "weekly":
          periodsPerYear = 52;
          break;
        case "biweekly":
          periodsPerYear = 26;
          break;
        case "monthly":
          periodsPerYear = 12;
          break;
        default:
          break;
          // throw new Error(`Invalid loan tenure type: ${loanTenureType}`);
      }

      // const periodRate = rateOfInterest / (periodsPerYear * 100);
      const periodRate = rateOfInterest / periodsPerYear;

      return periodRate;
    }

    const { chooseBorrower, chooseCoApplicant, chooseGuarantor } = this.state;
    return (
      <div>
        <Sidebar />
        <div style={{ textAlign: 'center', marginTop: '15px' }}>
          <div>
            <h3 className="Fonts headFontSize" style={{ marginLeft: '45px' }}><span className="backLink" onClick={this.backLinkAction.bind(this)}>{this.state.path}</span> / Add Loan</h3>
          </div>
        </div>

        <div className="addloancomponent">
          {/* <Grid item xs={10} style={{display:"none"}}><div></div></Grid> */}
          <div style={{marginLeft:'auto'}} className="xyz">
          <div className="LaontypeEntryDiv">
              <TextField
                id="standard-select-currency"
                select
                value={this.state.Entrylaontype || ""}
                onChange={this.EntryLoanTypeChange}
                className="LaontypeEntry"
              >
                {EntryLoanType.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
          </div>
          </div>
          {(this.state.Entrylaontype !== "EMI Method" && this.state.Entrylaontype !== "Flexi EMI") ? (
            <div>
              <Card className="cardDiv" onClick={this.checking.bind(this)}>
                <div className="previewComponent">
                  <form onSubmit={(e) => this._handleSubmit(e)}>
                    <div className="rowColumn">
                      <div className="rowColumn50100">
                        <div className="textFieldStyle Loan">
                          <h6 className="InputLabel Fonts SizeFont">{t('AddLoanType.Type')}</h6>
                          {/* <Input className="textBox" style={{ height: '35px', border: this.state.changeColorname }} onClick={this.nameBox} onChange={(event) => this.setState({ name: event.target.value })} /> */}
                          <TextField
                            id="standard-select-currency"
                            select
                            className="incomefield"
                            value={this.state.laontype || ""}
                            style={{ border: this.state.annual, width: "80%", height: "35px", border: "1px solid rgb(212, 212, 213)", borderRadius: "5px" }}
                            onClick={this.annualBox}
                            onChange={this.LoanChange}
                          >
                            {/* (event) => this.setState({ laontype: event.target.value }) */}
                            {this.state.LaonType.map(option => (
                              <MenuItem key={option.loanTypeId} value={option.loanType}>
                                {option.loanType}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                        <div className="textFieldStyle" style={{ width: '95%' }}>
                          <h6 className="InputLabel Fonts SizeFont">{"Loan given date"}</h6>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker disableToolbar variant="inline" format="dd/MM/yyyy" margin="normal" id="date-picker-inline" value={this.state.createdAt} onChange={this.handleDateCreatedChange.bind(this)} KeyboardButtonProps={{ 'aria-label': 'change date' }} />
                          </MuiPickersUtilsProvider>
                        </div>

                        {/* <div className="textFieldStyle">
                          <h6 className="InputLabel Fonts SizeFont">{t('AddLoan.penality')}</h6>
                          <div className="textBox" style={{ height: '35px', border: this.state.changeColoremail1, display: "flex" }}><span className="aboutfield">{countryCurrencySymbol}</span>
                            <Input type="number" value={this.state.penalty || ""} onClick={this.emailBox1} onChange={(event) => this.setState({ penalty: event.target.value,isdisabled:true,rows:[] })} />
                          </div>
                        </div> */}
                        {this.state.Entrylaontype === "Balloon Method" && (
                          <div className="textFieldStyle Loan">
                            <h6 className="InputLabel Fonts SizeFont">
                              {"Type of Balloon Method"}
                            </h6>
                            <Select
                              className="incomefield"
                              value={typeOfBM}
                              style={{
                                border: this.state.annual,
                                width: "80%",
                                height: "35px",
                                border: "1px solid rgb(212, 212, 213)",
                                borderRadius: "5px",
                              }}
                              disabled
                              // onClick={this.annualBox}
                              // onChange={(e) => this.setState({ typeOfBM: e.target.value})}
                              displayEmpty
                            >
                              <MenuItem value="interestOnly">
                                Interest Only
                              </MenuItem>
                            </Select>
                          </div>
                        )}
                        {/* {this.state.Entrylaontype === "Balloon Method" && typeOfBM === "partialEmi" && <div className="textFieldStyle">
                          <h6 className="InputLabel Fonts SizeFont">Last EMI Balloon Percentage</h6>
                          <div className="textBox" style={{ height: '35px', border: this.state.changeColoremail1, display: "flex" }}>
                            <Input type="number" value={lastEmiPercentageBM || ""}  onChange={(event) => this.setState({ lastEmiPercentageBM: event.target.value })} />
                          </div>
                        </div>} */}
                        {/* { this.state.Entrylaontype === "Balloon Method" &&
                          <div style={{display: "flex", flexDirection: "row"}} className="textFieldStyle">
                          <div>
                          <h6 className="InputLabel Fonts SizeFont">{"Loan given date"}</h6>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker disableToolbar variant="inline" format="dd/MM/yyyy" margin="normal" id="date-picker-inline" value={this.state.createdAt} onChange={this.handleDateCreatedChange.bind(this)} KeyboardButtonProps={{ 'aria-label': 'change date' }} />
                          </MuiPickersUtilsProvider>
                          </div>
                          <div style={{marginLeft: 10}}>
                          <h6 className="InputLabel Fonts SizeFont" >{t('AddLoan.date')}</h6>
                          <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker disableToolbar variant="inline" format="dd/MM/yyyy" margin="normal" id="date-picker-inline" value={this.state.SelectedDate} onChange={this.handleDateChange.bind(this)} KeyboardButtonProps={{ 'aria-label': 'change date' }} />
                          </MuiPickersUtilsProvider>
                          </div>
                        </div>
                        } */}
                        <div
                          className="textFieldStyle"
                          style={{ width: "95%" }}
                        >
                          <h6 className="InputLabel Fonts SizeFont">
                            {t("AddLoan.date")}
                          </h6>
                          <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              disableToolbar
                              variant="inline"
                              format="dd/MM/yyyy"
                              margin="normal"
                              id="date-picker-inline"
                              value={this.state.SelectedDate}
                              onChange={this.handleDateChange.bind(this)}
                              KeyboardButtonProps={{
                                "aria-label": "change date",
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </div>
                        {/* <div className="textFieldStyle Loan">
                          <h6 className="InputLabel Fonts SizeFont">
                            {"When Not Paid"}
                          </h6>
                          <Select
                            className="incomefield"
                            value={whenNotPaid}
                            style={{
                              border: this.state.annual,
                              width: "80%",
                              height: "35px",
                              border: "1px solid rgb(212, 212, 213)",
                              borderRadius: "5px",
                            }}
                            onClick={this.annualBox}
                            onChange={(e) =>
                              this.setState({
                                whenNotPaid: e.target.value,
                                autoUpdateNPD: "No",
                              })
                            }
                            displayEmpty
                          >
                            <MenuItem disabled value="">
                              Please Select
                            </MenuItem>
                            <MenuItem value="Yes">
                              Add Non payment Amount to the next Installment
                              Amount
                            </MenuItem>
                            <MenuItem value="No">
                              Increase the tenure of the Loan Repayment Schedule
                            </MenuItem>
                          </Select>
                        </div> */}
                        <div
                          className="textFieldStyle"
                          style={{ display: this.state.chooseBorrower, position: "relative" }}
                        >
                          <h6 className="InputLabel Fonts SizeFont">
                            {t("AddLoan.customer")}
                          </h6>
                          <div
                            style={{
                              height: "35px",
                              border: this.state.changeColoremail5,
                              display: "flex",
                              alignItems: "center",
                            }}
                            className="textBox"
                          >
                            <Input
                              list="browsers"
                              className="textBox"
                              placeholder="Choose Borrower"
                              value={chooseBorrower || ""}
                              onClick={this.emailBox5}
                              onChange={(e) => this.handleCustomerInputChange(e, "Borrower")}
                              onKeyDown={(event) => {
                                if (event.key === "Enter") {
                                  event.preventDefault();
                                  this.triggerCustomerSearch("Borrower");
                                }
                              }}
                              disabled={
                                this.props?.location?.params?.customerId
                                  ? true
                                  : false
                              }
                              onBlur={() => {
                                this.setState((prevState) => ({
                                  searchdoneBorrower: !prevState.customerId,
                                }));
                              }}
                            />
                            <IconButton
                              size="small"
                              onMouseDown={(event) => event.preventDefault()}
                              onClick={() => this.triggerCustomerSearch("Borrower")}
                              style={{ padding: "4px" }}
                            >
                              <img src={searchicon} alt="search" style={{ width: 16, height: 16 }} />
                            </IconButton>
                          </div>
                          {this.renderDropdown(
                            this.state.allBorrower,
                            "Borrower"
                          )}
                        </div>
                        <div className="textFieldStyle Loan">
                          <h6 className ="InputLabel Fonts SizeFont">{"Payment Mode"}</h6>
                          <TextField
                            id="standard-select-currency"
                            select
                            className="incomefield"
                            value={accountId || ""}
                            style={{
                              width: "80%",
                              height: "35px",
                              border: "1px solid rgb(212, 212, 213)",
                              borderRadius: "5px",
                            }}
                            onChange={this.handleAccountChange}
                          >
                            {filteredDataAccounts.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </div>
                        {(getSecureItem("loggedinUserCompany") === 2749) && (
                          <div
                            className="textFieldStyle"
                            style={{ display: this.state.chooseCoApplicant }}
                          >
                            <h6 className="InputLabel Fonts SizeFont">
                              {t("AddLoan.coApplicant")}
                            </h6>
                            <div
                              ref={this.coApplicantWrapperRef}
                              style={{ position: "relative" }}
                            >
                              <div
                                style={{
                                  height: "35px",
                                  border: this.state.changeColoremail6,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                className="textBox"
                              >
                                <Input
                                  list="browsers"
                                  className="textBox"
                                  placeholder="Choose Co Applicant"
                                  value={chooseCoApplicant || ""}
                                  onClick={this.emailBox6}
                                  onChange={(e) =>
                                    this.handleCustomerInputChange(e, "CoApplicant")
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      event.preventDefault();
                                      this.triggerCustomerSearch("CoApplicant");
                                    }
                                  }}
                                  disabled={
                                    this.props?.location?.params
                                      ?.coApplicantCustomerId
                                      ? true
                                      : false
                                  }
                                  onBlur={() =>
                                    this.setState({ searchdoneCoApplicant: true })
                                  }
                                />
                                <IconButton
                                  size="small"
                                  onMouseDown={(event) => event.preventDefault()}
                                  onClick={() => this.triggerCustomerSearch("CoApplicant")}
                                  style={{ padding: "4px" }}
                                >
                                  <img src={searchicon} alt="search" style={{ width: 16, height: 16 }} />
                                </IconButton>
                              </div>
                              {this.renderDropdown(
                                this.state.allCoApplicant,
                                "CoApplicant"
                              )}
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="rowColumn50100">
                        <div className="textFieldStyle">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginRight: "20%",
                            }}
                          >
                            <h6 className="InputLabel Fonts SizeFont">
                              {t("AddLoan.tenure")}
                            </h6>
                            <div className="rowColumn">
                              <select
                                onChange={this.searchSubmit}
                                className="monthlySelect"
                                value={selectedBrand}
                              >
                                {brands.map((brand) => (
                                  <option value={brand.name} key={brand.name}>
                                    {brand.name}
                                  </option>
                                ))}
                              </select>
                              <span
                                className="InputLabel Fonts linkFontSize"
                                style={{
                                  paddingLeft: "10px",
                                  textTransform: "capitalize",
                                }}
                              >
                                {this.state.tenure + " " + "range is:" + " "}

                                <span style={{ display: this.state.onetime }}>
                                  {this.state.onetimefrom +
                                    "-" +
                                    this.state.onetimeto}
                                </span>
                                <span style={{ display: this.state.days }}>
                                  {" "}
                                  {this.state.daysfrom +
                                    "-" +
                                    this.state.daysto}
                                </span>
                                <span style={{ display: this.state.months }}>
                                  {" "}
                                  {this.state.monthsfrom +
                                    "-" +
                                    this.state.monthsto}
                                </span>
                                <span style={{ display: this.state.weeks }}>
                                  {" "}
                                  {this.state.weeksfrom +
                                    "-" +
                                    this.state.weeksto}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div
                            style={{
                              height: "35px",
                              border: this.state.changeColoremail2,
                              display: "flex",
                            }}
                            className="textBox"
                          >
                            <Input
                              type="number"
                              onClick={this.emailBox2}
                              value={loantenure || ""}
                              onChange={(event) => {
                                this.setState({
                                  loantenure: event.target.value,
                                  isdisabled: true,
                                  rows: [],
                                  installment: this.returnInstallment(
                                    totalAmount,
                                    event.target.value
                                  ),
                                });
                                checkLoanTenure(
                                  onetimefrom,
                                  onetimeto,
                                  daysfrom,
                                  daysto,
                                  weeksfrom,
                                  weeksto,
                                  monthsfrom,
                                  monthsto,
                                  loantenure,
                                  tenure
                                );
                              }}
                            />
                            <span className="aboutfield">
                              {this.state.tenure}
                            </span>
                          </div>
                          <span
                            style={{
                              display:
                                loantenure != ""
                                  ? checkLoanTenure(
                                    onetimefrom,
                                    onetimeto,
                                    daysfrom,
                                    daysto,
                                    weeksfrom,
                                    weeksto,
                                    monthsfrom,
                                    monthsto,
                                    loantenure,
                                    tenure
                                  )
                                  : "none",
                            }}
                            className="InputLabel Fonts SizeFont"
                          >
                            Range is{" "}
                            <span style={{ display: onetime }}>
                              {onetimefrom + "-" + onetimeto}
                            </span>
                            <span style={{ display: days }}>
                              {" "}
                              {daysfrom + "-" + daysto}
                            </span>
                            <span style={{ display: months }}>
                              {" "}
                              {monthsfrom + "-" + monthsto}
                            </span>
                            <span style={{ display: weeks }}>
                              {" "}
                              {weeksfrom + "-" + weeksto}
                            </span>{" "}
                            only.{" "}
                            <a
                              style={{
                                textDecoration: "none",
                                color: "blue",
                                borderRadius: "5px",
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                this.props.history.push("/loantype")
                              }
                            >
                              Click here
                            </a>{" "}
                            to edit loan duration range.
                          </span>
                        </div>
                        {this.props.location?.params?.loanDetails?.totalReplanAmount &&
                          <div style={{ flex: 1, minWidth: "150px" }}>
                            <h6 className="InputLabel Fonts SizeFont">{"Previous loan over due amount"}</h6>
                            <div
                              style={{
                                height: "35px",
                                border: this.state.changeColoremail3,
                                display: "flex",
                              }}
                              className="textBox"
                            >
                              <span className="aboutfield">{countryCurrencySymbol}</span>
                              <Input
                                type="number"
                                style={{ height: "clamp(26px, 2.8vw, 33px)", fontSize: "clamp(11px, 1.4vw, 14px)" }}
                                value={this.props.location?.params?.loanDetails?.totalReplanAmount || ""}
                                disabled
                              />
                            </div>
                          </div>
                        }
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "15px",
                            alignItems: "flex-end",
                            flexWrap: "wrap",
                            width: "100%",
                            maxWidth:"630px",
                          }}
                        >
                          <div style={{ flex: 1, minWidth: "150px", maxWidth: "clamp(150px, 30vw, 260px)" }}>
                            <h6 className="InputLabel Fonts SizeFont">{"Loan Amount Given"}</h6>
                            <div
                              style={{
                                height: "clamp(28px, 3vw, 35px)",
                                border: this.state.changeColoremail3,
                                display: "flex",
                              }}
                              className="textBox"
                            >
                              <span className="aboutfield">{countryCurrencySymbol}</span>
                              <Input
                                type="number"
                                style={{ height: "clamp(26px, 2.8vw, 33px)", fontSize: "clamp(11px, 1.4vw, 14px)" }}
                                onClick={this.emailBox3}
                                value={this.state.distamount || ""}
                                onChange={(event) => {
                                  const amount = Number(event.target.value || 0);
                                  this.setState(
                                    {
                                      distamount: amount,
                                      isdisabled: true,
                                      rows: [],
                                      disableFeeInputs: true,
                                      installment:
                                        this.state.Entrylaontype === "Balloon Method"
                                          ? Math.round((amount * Number(this.state.roiBM)) / 100).toString()
                                          : this.returnInstallment(
                                            this.calculateTotalAmount(
                                              parseInt(amount),
                                              parseInt(fixedRoi),
                                              parseInt(this.state.loantenure),
                                              this.state.tenure
                                            ),
                                            loantenure
                                          ),
                                      totalAmount: this.calculateTotalAmount(
                                        parseInt(amount),
                                        parseInt(fixedRoi),
                                        parseInt(this.state.loantenure),
                                        this.state.tenure
                                      ),
                                    },
                                    () => this.recalculateFeesFromLoanAmount()
                                  );

                                  checkAmountRange(amountfrom, amountto, amount);
                                }}
                              />
                            </div>
                          </div>

                          <div style={{ flex: 1, minWidth: "150px", maxWidth: "clamp(150px, 30vw, 260px)" }}>
                            {this.state.Entrylaontype === "Balloon Method" ? (
                              <>
                                <h6 className="InputLabel Fonts SizeFont">{"Rate of Interest"}</h6>
                                <div
                                  style={{
                                    height: "clamp(28px, 3vw, 35px)",
                                    border: this.state.changeColoremail3,
                                    display: "flex",
                                  }}
                                  className="textBox"
                                >
                                  <span className="aboutfield">{"%"}</span>
                                  <Input
                                    type="number"
                                    style={{ height: "clamp(26px, 2.8vw, 33px)", fontSize: "clamp(11px, 1.4vw, 14px)" }}
                                    value={this.state.roiBM || ""}
                                    onChange={(event) => {
                                      const roiValue = event.target.value || 0;
                                      this.setState({
                                        roiBM: roiValue,
                                        installment: Math.round(
                                          (Number(this.state.distamount) * Number(roiValue)) / 100
                                        ).toString(),
                                      });
                                    }}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <h6 className="InputLabel Fonts SizeFont">{"Loan Amount to Collected"}</h6>
                                <div
                                  style={{
                                    height: "clamp(28px, 3vw, 35px)",
                                    border: this.state.changeColoremail3,
                                    display: "flex",
                                  }}
                                  className="textBox"
                                >
                                  <span className="aboutfield">{countryCurrencySymbol}</span>
                                  <Input
                                    type="number"
                                    style={{ height: "clamp(26px, 2.8vw, 33px)", fontSize: "clamp(11px, 1.4vw, 14px)" }}
                                    value={this.state.totalAmount || ""}
                                    onChange={(event) => {
                                      const total = Number(event.target.value || 0);
                                      this.setState({
                                        totalAmount: total,
                                        isdisabled: true,
                                        rows: [],
                                        installment: this.returnInstallment(total, loantenure),
                                      });
                                    }}
                                  />
                                </div>
                              </>
                            )}
                          </div>

                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "15px",
                            alignItems: "flex-end",
                            flexWrap: "wrap",
                            width: "100%",
                            maxWidth:"630px",
                          }}
                        >
                          <div style={{ flex: 1, minWidth: "150px", maxWidth: "clamp(150px, 30vw, 260px)" }}>
                            <h6 className="InputLabel Fonts SizeFont">
                              {"Processing Fee"}
                            </h6>
                            <div
                              style={{
                                height: "35px",
                                border: this.state.changeColoremail3,
                                display: "flex",
                              }}
                              className="textBox"
                            >
                              <span className="aboutfield">
                                {countryCurrencySymbol}
                              </span>
                              <Input
                                type="number"
                                onClick={this.emailBox3}
                                value={this.state.processFee || ""}
                                onChange={(event) => {
                                  this.setState({
                                    processFee: event.target.value,
                                    isdisabled: true,
                                    rows: [],
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div style={{ flex: 1, minWidth: "150px", maxWidth: "clamp(150px, 30vw, 260px)" }}>
                            <h6 className="InputLabel Fonts SizeFont">{t("AddLoan.instal")}</h6>
                            <div
                              style={{
                                height: "clamp(28px, 3vw, 35px)",
                                border: this.state.changeColoremail4,
                                display: "flex",
                              }}
                              className="textBox"
                            >
                              <span className="aboutfield">{countryCurrencySymbol}</span>
                              <Input
                                type="number"
                                disabled
                                value={this.state.installment || ""}
                                style={{ height: "clamp(26px, 2.8vw, 33px)", fontSize: "clamp(11px, 1.4vw, 14px)" }}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="textFieldStyle">
                          <h6 className="InputLabel Fonts SizeFont">{t('AddLoan.instal')}</h6>
                          <div style={{ height: '35px', border: this.state.changeColoremail4, display: "flex" }} className="textBox"><span className="aboutfield">{countryCurrencySymbol}</span>
                            <Input type="number" onClick={this.emailBox4} value={this.state.installment || ""} onChange={(event) => this.setState({ installment: event.target.value,isdisabled:true,rows:[] })} />
                          </div>
                        </div> */}
                        <Card
                          className="feeCard"
                          style={{
                            padding: "15px",
                            width: "100%",
                            boxSizing: "border-box",
                          }}
                        >
                          <div className='feeCardHeader'>
                            <h6 className="feeLabel">Additional Fees</h6>

                            <span
                              onClick={this.addFeeDetails}
                              style={{
                                cursor: "pointer",
                                color: "#1976d2",
                                textDecoration: "underline",
                                fontSize: "14px",
                                fontWeight: "500",
                                paddingRight: "4px",
                              }}
                            >
                              + Add Fee
                            </span>
                          </div>

                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
                              gap: "15px",
                              width: "100%",
                              maxHeight: "220px",
                              overflowY: this.state.feedetails.length > 6 ? "auto" : "visible",
                              paddingRight: "5px",
                              marginBottom:"25px"
                            }}
                          >
                            {this.state.feedetails.map((fee) => (
                              <div key={fee.feeId} style={{ minWidth: "180px" }}>
                                <label
                                  style={{
                                    fontSize: "12px",
                                    fontWeight: "500",
                                    color: "#8E8E98",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {fee.name} ({fee.calculation})
                                </label>

                                <div className="feeInputContainer">
                                  <span>{countryCurrencySymbol}</span>
                                  <input
                                    type="number"
                                    value={this.state.feeValues?.[fee.name] || ""}
                                    onChange={(e) => this.handleFeeValueChange(e, fee)}
                                  />
                                </div>
                              </div>
                            ))}
                          </div>

                          {/* <div
                            style={{
                              marginTop: "20px",
                              width: "100%",
                              maxWidth: "260px",
                            }}
                          >
                            <label
                              style={{
                                fontSize: "12px",
                                fontWeight: "500",
                                color: "#8E8E98",
                              }}
                            >
                              <b>Total Fee</b>
                            </label>

                            <div
                              className="feeInputContainer"
                              style={{
                                backgroundColor: "#efefef",
                                border: this.state.changeColoremail3,
                              }}
                            >
                              <span>{countryCurrencySymbol}</span>
                              <input type="number" readOnly value={this.state.totalFee || 0} />
                            </div> 
                          </div> */}
                        </Card>

                        <span
                          style={{
                            display:
                              distamount != ""
                                ? checkAmountRange(
                                  amountfrom,
                                  amountto,
                                  distamount
                                )
                                : "none",
                          }}
                          className="InputLabel Fonts SizeFont"
                        >
                          Range is{" "}
                          {this.state.amountfrom + " - " + this.state.amountto}{" "}
                          only.{" "}
                          <a
                            style={{
                              textDecoration: "none",
                              color: "blue",
                              borderRadius: "5px",
                              cursor: "pointer",
                            }}
                            onClick={() => this.props.history.push("/loantype")}
                          >
                            Click here
                          </a>{" "}
                          to edit loan amount range.
                        </span>
                        {(getSecureItem("loggedinUserCompany") === 2749) && (
                          <div
                            className="textFieldStyle"
                            style={{ display: this.state.guarantor }}
                          >
                            <h6 className="InputLabel Fonts SizeFont">
                              {t("AddLoan.guarantor")}
                            </h6>
                            <div
                              ref={this.guarantorWrapperRef}
                              style={{ position: "relative" }}
                            >
                              <div
                                style={{
                                  height: "35px",
                                  border: this.state.changeColoremail7,
                                  display: "flex",
                                  alignItems: "center",
                                }}
                                className="textBox"
                              >
                                <Input
                                  list="browsers"
                                  className="textBox"
                                  placeholder="Choose Guarantor"
                                  value={chooseGuarantor || ""}
                                  onClick={this.emailBox7}
                                  onChange={(e) =>
                                    this.handleCustomerInputChange(e, "Guarantor")
                                  }
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      event.preventDefault();
                                      this.triggerCustomerSearch("Guarantor");
                                    }
                                  }}
                                  disabled={
                                    this.props?.location?.params
                                      ?.coGuarantorCustomerId
                                      ? true
                                      : false
                                  }
                                  onBlur={() =>
                                    this.setState({ searchdoneGuarantor: true })
                                  }
                                />
                                <IconButton
                                  size="small"
                                  onMouseDown={(event) => event.preventDefault()}
                                  onClick={() => this.triggerCustomerSearch("Guarantor")}
                                  style={{ padding: "4px" }}
                                >
                                  <img src={searchicon} alt="search" style={{ width: 16, height: 16 }} />
                                </IconButton>
                              </div>
                              {this.renderDropdown(
                                this.state.allGuarantor,
                                "Guarantor"
                              )}
                            </div>
                          </div>
                        )}
                        {/* <div className="textFieldStyle Loan">
                          <h6 className="InputLabel Fonts SizeFont">{"Auto Update Non Paid Dues(EOD)"}</h6>
                          <Select
                            className="incomefield"
                            value={autoUpdateNPD}
                            style={{ border: this.state.annual, width: "80%", height: "35px", border: "1px solid rgb(212, 212, 213)", borderRadius: "5px" }}
                            onClick={this.annualBox}
                            disabled={true}
                            onChange={(e) => this.setState({ autoUpdateNPD: e.target.value })}
                            displayEmpty
                          >
                            <MenuItem disabled value="">
                              Please Select
                            </MenuItem>
                            <MenuItem value="Yes">
                              Yes
                            </MenuItem>
                            <MenuItem value="No">
                              No
                            </MenuItem>
                          </Select>
                        </div> */}
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginLeft: "5%",
                        marginRight: "5%",
                        marginTop: "5%",
                      }}
                      className="rowColumn"
                    >
                      <div
                        className="rowColumn"
                        style={{
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className="savebutton btnSizeFont Fonts"
                          onClick={this.betweenRange}
                        >
                          {t("AddLoan.buttn1")}
                        </Button>
                        <Button
                          className="cancelbutton btnSizeFont Fonts"
                          onClick={this.clear.bind(this)}
                        >
                          {t("AddLoan.buttn2")}
                        </Button>
                      </div>
                      {(() => {
                        // Safely parse values, defaulting to 0 instead of NaN
                        const distAmount = parseFloat(this.state.distamount) || 0;
                        const processFee = parseFloat(this.state.processFee) || 0;
                        const totalAmount = parseFloat(this.state.totalAmount) || 0;
                        const prevOverDue = parseFloat(this.props.location?.params?.loanDetails?.totalReplanAmount) || 0;

                        let addOnFeeTotal = 0;
                        let deductableFeeTotal = 0;

                        this.state.feedetails.forEach((fee) => {
                          const feeAmount = parseFloat(this.state.feeValues?.[fee.name]) || 0;
                          if (fee.category === "Add-On Fee") {
                            addOnFeeTotal += feeAmount;
                          } else if (fee.category === "Deductable Fee") {
                            deductableFeeTotal += feeAmount;
                          }
                        });

                        let cashGiven = distAmount - processFee - deductableFeeTotal;
                        if (prevOverDue) {
                          cashGiven = cashGiven - prevOverDue;
                        }
                        const profit = totalAmount - distAmount + deductableFeeTotal + processFee;

                        return (
                          <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                            <div className="mt2" style={{ textAlign: "center" }}>
                              <div className="TotalMoney">
                                <input
                                  placeholder={countryCurrencySymbol}
                                  value={cashGiven ? cashGiven.toFixed(2) : ""}
                                  className="displaytotalmoney"
                                  disabled
                                  style={{ backgroundColor: "transparent", textAlign: "center" }}
                                />
                              </div>
                              <span className="Fonts instalment" style={{ display: "block", textAlign: "center" }}>
                                Cash Given
                              </span>
                            </div>

                            <div className="mt2" style={{ textAlign: "center" }}>
                              <div className="TotalMoney">
                                <input
                                  placeholder={countryCurrencySymbol}
                                  value={profit ? profit.toFixed(2) : ""}
                                  className="displaytotalmoney"
                                  disabled
                                  style={{ backgroundColor: "transparent", textAlign: "center" }}
                                />
                              </div>
                              <span className="Fonts instalment" style={{ display: "block", textAlign: "center" }}>
                                Profit
                              </span>
                            </div>

                            <div className="mt2" style={{ textAlign: "center" }}>
                              <div className="TotalMoney">
                                <input
                                  placeholder={countryCurrencySymbol}
                                  value={this.state.totalAmount || ""}
                                  className="displaytotalmoney"
                                  disabled
                                  style={{ backgroundColor: "transparent", textAlign: "center" }}
                                />
                              </div>
                              <span className="Fonts instalment" style={{ display: "block", textAlign: "center" }}>
                                {this.state.Entrylaontype === "Balloon Method"
                                  ? "Installment amount to be paid"
                                  : t("AddLoan.circle")}
                              </span>
                            </div>
                          </div>
                        );
                      })()}
                    </div>
                  </form>
                </div>
              </Card>
            </div>
          ) : (
            <AddLoan
              method={this.state.Entrylaontype}
              onRef={(ref) => (this.child = ref)}
              collectionagent={this.state.collectionagent}
              TableData={this.TableData}
              isdisabled={this.state.isdisabled}
              customerId={this.props?.location?.params?.customerId}
              coApplicantCustomerId={this.props?.location?.params?.coApplicantCustomerId}
              guarantorCustomerId={this.props?.location?.params?.guarantorCustomerId}
              replanLoanDetails={
                  this.props.location?.params?.midReplan
                    ? this.props.location.params.loanDetails
                    : null
                }
              previousOverDueAmount={this.props.location?.params?.loanDetails?.totalReplanAmount}
              previousLoanId={this.state.previousLoanId}
              closingDate={this.props.location?.params?.closingDate}
              chooseBorrower={
                this.props?.location?.params?.cust_id
                  ? `${this.props?.location?.params?.firstName} ${this.props?.location?.params?.lastName} (${this.props?.location?.params?.cust_id})`
                  : `${this.props?.location?.params?.firstName} ${this.props?.location?.params?.lastName}`
              }
              chooseCoApplicant={
                this.props?.location?.params?.cust_id
                  ? `${this.props?.location?.params?.firstName} ${this.props?.location?.params?.lastName} (${this.props?.location?.params?.cust_id})`
                  : `${this.props?.location?.params?.firstName} ${this.props?.location?.params?.lastName}`
              }
              chooseGuarantor={
                this.props?.location?.params?.cust_id
                  ? `${this.props?.location?.params?.firstName} ${this.props?.location?.params?.lastName} (${this.props?.location?.params?.cust_id})`
                  : `${this.props?.location?.params?.firstName} ${this.props?.location?.params?.lastName}`
              }
            />
          )}
          {/* <div style={{ display: "flex", paddingBottom: "10px" }}>
            <div
              style={{
                paddingLeft: "10rem",
                paddingTop: "11px",
                width: "60.5%",
              }}
              className="Fonts"
            >
              {t("AddLoan.tablename")}
            </div>
          </div> */}
          <div className="cardDiv2">
            <div
              style={{
                paddingBottom: "10px",
                paddingTop: "10px",
              }}
              className="Fonts"
            >
              {t("AddLoan.tablename")}
            </div>
            <div>
              <Table className="table">
                <TableHead>
                  <TableRow
                    style={{ backgroundColor: "#E1F0FA", color: "#B2B2B2" }}
                  >
                    <TableCell>{this.state.tenure}</TableCell>
                    <TableCell align="right">Due Date</TableCell>
                    <TableCell align="right">Opening Balance</TableCell>
                    <TableCell align="right">Installment</TableCell>
                    <TableCell
                      align="right"
                      style={{ display: this.state.calInterest }}
                    >
                      Principal Amt.
                    </TableCell>
                    <TableCell
                      align="right"
                      style={{ display: this.state.calInterest }}
                    >
                      Interest
                    </TableCell>
                    <TableCell align="right">Closing Balance</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {/* Month, Opening, Amt, Interest, Principal, Closing, Due */}
                  {this.state.rows &&
                    this.state.rows.map((row, index) => (
                      <TableRow
                        key={index}
                        className="Roww TextColour"
                        style={{ marginBottom: "30px" }}
                      >
                        <TableCell align="right" className="changetext">
                          {index + 1}
                        </TableCell>
                        <TableCell align="right" className="changetext">
                          {moment(row.scheduledDate).format("DD MMM YYYY")}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <div style={{ display: "flex" }}>
                            <p
                              style={{
                                paddingLeft: "10px",
                                fontWeight: "800",
                                color: "#3E4664",
                              }}
                              className="changetext"
                            >
                              {" "}
                              {row.openingBalance}{" "}
                            </p>
                          </div>
                        </TableCell>
                        <TableCell align="right" className="changetext">
                          {row.collectionAmount}
                        </TableCell>
                        <TableCell
                          align="right"
                          className="changetext"
                          style={{ display: this.state.calInterest }}
                        >
                          {row.principal}
                        </TableCell>
                        <TableCell
                          align="right"
                          className="changetext"
                          style={{ display: this.state.calInterest }}
                        >
                          {row.interest}
                        </TableCell>
                        <TableCell align="right" className="changetext">
                          {row.closingBalance}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </div>
          </div>
          {/* <div style={{display:"flex", marginLeft:"10.5rem", color: "#3E4664"}} className="Fonts">
          <div style={{width:"40.5%", color: "#3E4664"}} className="Fonts">Total</div>
          <div style={{width:"14%", color: "#3E4664"}} className="Fonts">66541551565</div>
          <div className="Fonts" style={{color: "#3E4664"}}>9884</div>
      </div> */}
          <Card className="cardDiv3">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",

                marginTop: "5%",
              }}
              className="rowColumn"
            >
              <div>
                <h6 className="Fonts assign">{t("AddLoan.agents")} </h6>
                <div>
                  <TextField
                    id="standard-select-currency"
                    select
                    className="field"
                    value={this.state.collectionagent}
                    fullWidth
                    style={{
                      border: this.state.annual,
                      border: "1px solid rgb(212, 212, 213)",
                      borderRadius: "5px",
                    }}
                    onClick={this.annualBox}
                    onChange={this.collectionangentChange.bind(this)}
                  >
                    {this.state.Collectors &&
                      this.state.Collectors.map((option) => (
                        <MenuItem key={option.userId} value={option.userId}>
                          {option.firstName} {option.lastName}
                        </MenuItem>
                      ))}
                  </TextField>
                </div>
              </div>
              <div className="mt2">
                <div
                  className="rowColumn"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    className="cancel btnSizeFont Fonts"
                    onClick={this.cancel.bind(this)}
                  >
                    Cancel
                  </Button>
                  {this.state.Entrylaontype === "Collection method" && (
                    <Button
                      style={{ display: this.state.ButtonAction }}
                      className="save btnSizeFont Fonts"
                      onClick={this.postLoannoInterest.bind(this)}
                      disabled={this.state.isdisabled}
                    >
                      Save
                    </Button>
                  )}
                  {this.state.Entrylaontype === "Balloon Method" && (
                    <Button
                      className="save btnSizeFont Fonts"
                      onClick={this.postLoannoInterest.bind(this)}
                    >
                      Save
                    </Button>
                  )}
                  {this.state.Entrylaontype === "EMI Method" && (
                    <Button
                      style={{ display: this.state.InterestButtonAction }}
                      className="save btnSizeFont Fonts"
                      onClick={this.postLoanInterest}
                      disabled={this.state.isdisabled}
                    >
                      Save
                    </Button>
                  )}
                  {this.state.Entrylaontype === "Flexi EMI" && (
                    <Button
                      style={{ display: this.state.InterestButtonAction }}
                      className="save btnSizeFont Fonts"
                      onClick={this.postLoanInterest}
                      disabled={this.state.isdisabled}
                    >
                      Save
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {/* <div>
              <h6 className="Fonts assign">{t("AddLoan.agents")} </h6>
              <div>
                <TextField
                  id="standard-select-currency"
                  select
                  className="field"
                  value={this.state.collectionagent}
                  style={{
                    border: this.state.annual,
                    width: "37%",
                    height: "35px",
                    border: "1px solid rgb(212, 212, 213)",
                    borderRadius: "5px",
                  }}
                  onClick={this.annualBox}
                  onChange={this.collectionangentChange.bind(this)}
                >
                  {this.state.Collectors &&
                    this.state.Collectors.map((option) => (
                      <MenuItem key={option.userId} value={option.userId}>
                        {option.firstName} {option.lastName}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
            </div>
            <div style={{ textAlign: "end" }}>
              <Button
                className="cancel btnSizeFont Fonts"
                onClick={this.cancel.bind(this)}
              >
                Cancel
              </Button>
              <Button
                style={{ display: this.state.ButtonAction }}
                className="save btnSizeFont Fonts"
                onClick={this.postLoannoInterest.bind(this)}
                disabled={this.state.isdisabled}
              >
                Save
              </Button>
              <Button
                style={{ display: this.state.InterestButtonAction }}
                className="save btnSizeFont Fonts"
                onClick={this.postLoanInterest}
                disabled={this.state.isdisabled}
              >
                Save
              </Button>
            </div> */}
          </Card>
        </div>
      </div>
    );
  }
}
export default withNamespaces()(AddLoanWithoutInterest);
